module.exports = __webpack_public_path__ + "img/Cas9variants_H.3d35e964.svg";